import type { CountryConfiguration } from '@rover/rsdk/src/apiClient/latest';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const countryConfigurationsUrl = fullApiUrl('country-configuration/');
export const currentCountryConfigurationUrl = fullApiUrl('country-configuration/current/');
export const navigationCountryConfigurationUrl = fullApiUrl('country-configuration/navigation/');

export const getAll = async (): Promise<CountryConfiguration[]> => {
  const ai = getAxiosInstance();

  try {
    const response = await ai.get<Snakeify<{ results: CountryConfiguration[] }>>(
      countryConfigurationsUrl
    );
    return camelize(response.data.results, true);
  } catch (error: any) {
    throw DefaultAPIErrorHandler(error, 'There was an error getting your country configuration.');
  }
};

export const getCurrent = async (): Promise<CountryConfiguration> => {
  const ai = getAxiosInstance();

  try {
    const response = await ai.get(currentCountryConfigurationUrl);
    return camelize(response.data, true) as CountryConfiguration;
  } catch (error: any) {
    throw DefaultAPIErrorHandler(
      error,
      'There was an error getting your current country configuration.'
    );
  }
};

export const getNavigation = async (): Promise<CountryConfiguration> => {
  const ai = getAxiosInstance();

  try {
    const response = await ai.get(navigationCountryConfigurationUrl);
    return camelize(response.data, true) as CountryConfiguration;
  } catch (error: any) {
    throw DefaultAPIErrorHandler(
      error,
      'There was an error getting your navigation country configuration.'
    );
  }
};
